import React, { useEffect, useState } from "react";
import style from "./UserManagement.module.css";
import axios from "axios";
import { baseUrl } from "../../data/baseURL";

export default function UserManagement(props) {
    let [data, setData] = useState([]);
    let [showUi, setShowUi] = useState(false);
    let [currentEditingPhoneNumber, setCurrentEditingPhoneNumber] = useState("");
    let [currentPermissions, setCurrentPermissions] = useState([]);
    useEffect(() => {
        axios.get(baseUrl + "/Auth/Users", {
            headers: {
                Authorization: "Bearer " + localStorage.getItem("token")
            }
        }).then((res) => {
            setData(res.data?.data);
        });
    }, []);

    useEffect(() => {
    }, [currentPermissions]);

    function editHandle(index) {
        axios.get(baseUrl + "/Auth/Users", {
            headers: {
                Authorization: "Bearer " + localStorage.getItem("token")
            }
        }).then((res) => {
            setData(res.data?.data);
            setCurrentPermissions([...res.data?.data[index].permissions]);
        });
        setCurrentEditingPhoneNumber(data[index].phoneNumber);
         // Ensure to set permissions from the selected user
        setShowUi(true);
    }

    function closeHandle() {
        setCurrentEditingPhoneNumber("");
        setCurrentPermissions([]);
        setShowUi(false);
    }

    function clickHandle(permission) {
        if (currentPermissions.includes(permission)) {
            let cachePermissions = currentPermissions.filter(p => p !== permission);
            setCurrentPermissions(cachePermissions);
            axios.post(baseUrl + "/Auth/ChangeUserPermission", {
                phoneNumber: currentEditingPhoneNumber,
                permission: permission
            }, {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("token")
                }
            }).catch(() => {
                let cachePermissions = [...currentPermissions, permission];
                setCurrentPermissions(cachePermissions);
            });
        } else {
            let cachePermissions = [...currentPermissions, permission];
            setCurrentPermissions(cachePermissions);
            axios.post(baseUrl + "/Auth/ChangeUserPermission", {
                phoneNumber: currentEditingPhoneNumber,
                permission: permission
            }, {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("token")
                }
            }).catch(() => {
                let cachePermissions = currentPermissions.filter(p => p !== permission);
                setCurrentPermissions(cachePermissions);
            });
        }
    }

    return (
        <div className={`${style.container}`}>
            <div className={`${showUi ? style.popup : style.popup_hidden}`}>
                <div className={`${style.popup_container}`}>
                    <div className={`${style.popup_header}`} onClick={() => closeHandle()}>
                        <div className={`${style.popup_header_title}`}>
                            مدیریت یوزر
                        </div>
                        <div className={`${style.popup_header_icon}`}>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" style={{ width: "20px", height: "20px" }}>
                                <path d="M345 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-119 119L73 103c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l119 119L39 375c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l119-119L311 409c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-119-119L345 137z" />
                            </svg>
                        </div>
                    </div>
                    <div className={`${style.popup_content}`}>
                        {[0, 3, 1, 2, 5].map((permission, index) => (
                            <div className={`${style.checkbox}`} key={permission} onClick={() => clickHandle(permission)}>
                                <input type="checkbox" className={`${style.checkbox_input}`} checked={currentPermissions.includes(permission)} readOnly />
                                <div className={`${style.checkbox_title}`}>
                                    {permission === 0 ? "سوپر یوزر" :
                                        permission === 3 ? "بن شده" :
                                        permission === 1 ? "مدیریت عکس ها" :
                                        permission === 2 ? "مدیریت روایت ها" :
                                        "مدیریت یوزر"}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <div className={`${style.header}`}>
                <div className={`${style.header_title}`}>
                    مدیریت کاربران
                </div>
            </div>
            <div className={`${style.content}`}>
                <div className={`${style.table}`}>
                    <div className={`${style.table_header}`}>
                        <div className={`${style.table_header_item}`} style={{ width: "20%" }}>
                            ردیف
                        </div>
                        <div className={`${style.table_header_item}`} style={{ width: "20%" }}>
                            نام کاربر
                        </div>
                        <div className={`${style.table_header_item}`} style={{ width: "20%" }}>
                            شماره تلفن
                        </div>
                        <div className={`${style.table_header_item}`} style={{ width: "20%" }}>
                            دسترسی
                        </div>
                        <div className={`${style.table_header_item}`} style={{ width: "20%" }}>
                            اکشن ها
                        </div>
                    </div>
                    <div className={`${style.table_body}`}>
                        {
                            data.map((d, index) => (
                                <div className={`${style.table_body_i}`} key={index}>
                                    <div className={`${style.table_body_item}`} style={{ width: "20%" }}>
                                        {index + 1}
                                    </div>
                                    <div className={`${style.table_body_item}`} style={{ width: "20%" }}>
                                        {d.firstName + " " + d.lastName}
                                    </div>
                                    <div className={`${style.table_body_item}`} style={{ width: "20%" }}>
                                        {d.phoneNumber}
                                    </div>
                                    <div className={`${style.table_body_item}`} style={{ width: "20%" }}>
                                        {d.permissions.includes(0) ? "سوپر یوزر" : d.permissions.includes(3) ? "بن شده" : d.permissions.length > 1 ? "دسترسی محدود" : "بدون دسترسی"}
                                    </div>
                                    <div className={`${style.table_body_item}`} style={{ width: "20%" }}>
                                        <div className={`${style.table_actions}`}>
                                            <div className={`${style.table_actions_edit}`} title="ویرایش" onClick={() => editHandle(index)}>
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M36.4 360.9L13.4 439 1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1L73 498.6l78.1-23c12.4-3.6 23.7-9.9 33.4-18.4c1.4-1.2 2.7-2.5 4-3.8L492.7 149.3c21.9-21.9 24.6-55.6 8.2-80.5c-2.3-3.5-5.1-6.9-8.2-10L453.3 19.3c-25-25-65.5-25-90.5 0L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4zm46 13.5c1.7-5.6 4.5-10.8 8.4-15.2c.6-.6 1.1-1.2 1.7-1.8L321 129 383 191 154.6 419.5c-4.7 4.7-10.6 8.2-17 10.1l-23.4 6.9L59.4 452.6l-1-1.5l-1.8-1.9l-.8-1.4l-4.4-7.1 6.9-23.4c2-6.4 5.5-12.3 10.1-17L370 129l5.2-5.2L384 114l-17.4-17.4L332 38l17.4-17.4c13.7-13.7 35.9-13.7 49.6 0l14.3 14.3c13.7 13.7 13.7 35.9 0 49.6L341.8 97l-11.2 11.2l-170.5 170.4c-6.7 6.7-11.8 14.9-15.1 24.5L36.4 374.4z" /></svg>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}
